import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { LANGUAGES, STORAGE_KEY } from "@/i18n";
import { api } from "@/lib/api";

export const LanguageSelector = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const current = (i18n.language || "it").slice(0, 2);
  const [busy, setBusy] = useState(false);

  const change = async (code) => {
    if (code === current || busy) return;
    setBusy(true);
    try {
      localStorage.setItem(STORAGE_KEY, code);
      await i18n.changeLanguage(code);
      // Salva la preferenza sul profilo (se autenticato), sincronizzata tra dispositivi.
      api.put("/profile", { language: code }).catch(() => {});
      // Ricarica per ri-ottenere i contenuti dinamici nella nuova lingua.
      window.location.reload();
    } catch (e) {
      setBusy(false);
    }
  };

  return (
    <div className={`relative inline-flex items-center ${className}`} data-testid="language-selector">
      <Globe size={16} className="absolute left-3 text-anima-muted pointer-events-none" />
      <select
        value={current}
        onChange={(e) => change(e.target.value)}
        aria-label="Lingua / Language"
        data-testid="language-select"
        className="appearance-none rounded-full bg-white/70 border border-anima-ink/12 pl-9 pr-8 py-2 text-sm text-anima-ink outline-none cursor-pointer"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </div>
  );
};
